import React, { ReactNode, useCallback, useState } from 'react';

import { IPortalContextValue, PortalContext } from './PortalContext';

interface IPortalProviderProps {
  children: ReactNode;
}

export function PortalProvider({ children }: IPortalProviderProps): JSX.Element {
  const [gates, setGates] = useState<Record<string, JSX.Element>>({});

  const teleport = useCallback((gateName: string, element: JSX.Element) => {
    setGates((prevGates) => {
      const updatedGates = { ...prevGates };
      delete updatedGates[gateName];

      updatedGates[gateName] = element;

      return updatedGates;
    });
  }, []);

  const removeGate = useCallback((gateName: string) => {
    setGates((prevGates) => {
      const updatedGates = { ...prevGates };
      delete updatedGates[gateName];
      return updatedGates;
    });
  }, []);

  const removeAllGate = useCallback(() => {
    setGates({});
  }, []);

  const contextValue: IPortalContextValue = {
    gates,
    teleport,
    removeGate,
    removeAllGate
  };

  return <PortalContext.Provider value={contextValue}>{children}</PortalContext.Provider>;
}
